import {useEffect, useRef} from 'react';

import type {UseUwmHostParams} from './types';

const UWM_COMMAND_EVENT = 'UwmCommand';

export const useUwmHost = (params: UseUwmHostParams): void => {
    const paramsRef = useRef(params);
    const hasAnnouncedRef = useRef(false);

    paramsRef.current = params;

    useEffect(() => {
        const onMessage = (event: MessageEvent) => {
            const detail = event?.data?.detail;

            if (detail?.command) paramsRef.current.processCommand(detail);
        };

        const onCustomEvent = (event: Event) => {
            const detail = (event as CustomEvent)?.detail;

            if (detail?.command) paramsRef.current.processCommand(detail);
        };

        window.addEventListener('message', onMessage);
        document.addEventListener(UWM_COMMAND_EVENT, onCustomEvent);

        const rootElement = document.getElementById(paramsRef.current.rootElementId ?? 'root');
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) paramsRef.current.onResize(entry.contentRect.height);
        });

        if (rootElement) {
            resizeObserver.observe(rootElement);
        }

        if (!hasAnnouncedRef.current) {
            hasAnnouncedRef.current = true;
            paramsRef.current.onLoaded();
        }

        return () => {
            window.removeEventListener('message', onMessage);
            document.removeEventListener(UWM_COMMAND_EVENT, onCustomEvent);
            resizeObserver.disconnect();
        };
    }, []);
};
